enum HistoryEventTypes {
  DoorAdded = 'DoorAdded',
  DoorInstallationPassed = 'DoorInstallationPassed',
  DoorInstallationFailed = 'DoorInstallationFailed',
  DoorInspectionPassed = 'DoorInspectionPassed',
  DoorInspectionFailed = 'DoorInspectionFailed',
  DoorPPMPassed = 'DoorPPMPassed',
  DoorPPMFailed = 'DoorPPMFailed',
  DoorMaintenance = 'DoorMaintenance',
  DoorDisabled = 'DoorDisabled',
  DoorRetired = 'DoorRetired',
  DoorRepairRequested = 'DoorRepairRequested',
  DoorRepaired = 'DoorRepaired',
  DoorNotAccessible = 'DoorNotAccessible',
  DoorAssigned = 'DoorAssigned',
  DoorInstallationReported = 'DoorInstallationReported',
  DoorUpdated = 'DoorUpdated',
  DoorUnassigned = 'DoorUnassigned',
  DoorNoteAdded = 'DoorNoteAdded',
  PackAppliedToDoor = 'PackAppliedToDoor',
}
export default HistoryEventTypes;
